import { isObject } from 'lodash'

export const processPartyEditRequirements = party => {
  return {
    ...party,
    // Personal Data
    identifiers: party.identifiers || [],
    ethnicity: party.ethnicity || [],
    race: party.race || [],
    religion: party.religion || [],
    emails: party.emails || [],
    akas: party.akas || [],
    narratives: party.narratives || [],
    phones: party.phones || [],
    addresses: party.addresses || [],
    immigration_statuses: party.immigration_statuses || [],
    passports: party.passports || [],
    // Family
    spouses: party.spouses || [],
    children: party.children || [],
    parents: party.parents || [],
    siblings: party.siblings || [],
    // Background
    immigration_benefits: party.immigration_benefits || [],
    immigration_proceedings: party.immigration_proceedings || [],
    learned_languages: party.learned_languages || [],
    travel_histories: party.travel_histories || [],
    // History
    education_histories: party.education_histories || [],
    criminal_histories: party.criminal_histories || [],
    detention_histories: party.detention_histories || [],
    job_histories: party.job_histories || [],
    residence_histories: party.residence_histories || [],
    // Surveys
    surveys: party.surveys || [],
  }
}

export const fullBooleanReducer = obj => Object.values(obj || {}).
  reduce((acc, value) => (isObject(value) ? fullBooleanReducer(value) : value) && acc, true)

export const fullPartySectionSetter = (obj, value) => Object.keys(obj || {}).
  reduce((acc, key) => {
    if (isObject(obj[key])) acc[key] = fullPartySectionSetter(obj[key], value)
    else acc[key] = value

    return acc
  }, {})
